import React from 'react'
import type { RetorikActivity } from '../../models/activityTypes'
import ListContextProvider from '../Contexts/ListContextProvider'
import List from './List/List'

interface TemplateListProps {
  activity?: RetorikActivity
  onClose?: () => void
}

const TemplateList = ({ activity, onClose }: TemplateListProps): JSX.Element => {
  return (
    <ListContextProvider>
      <List activity={activity} onClose={onClose} />
    </ListContextProvider>
  )
}

export default TemplateList
